<app-loader></app-loader>

<!-- Add Balance Modal -->
<div class="fixed inset-0 bg-black/75 backdrop-blur-[6px] flex items-center justify-center modal-overlay Add_Bal z-[999]"
  *ngIf="showModal" (click)="hideWalletModal()">
  <div class="bg-[#0D1117] rounded-3xl w-full max-w-lg shadow-[0_24px_60px_rgba(0,0,0,0.7)] border border-[#1E293B] modal slide-up overflow-hidden"
    (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="flex-shrink-0 flex items-center justify-between px-5 py-4 bg-transparent">
      <div class="flex items-center gap-3">
        @if (selectedAccountType) {
        <button (click)="selectedAccountType = ''; showcard = false; showcashApp = false; showChimeZelle = false"
          class="w-7 h-7 flex items-center justify-center rounded-[7px] border border-[#1E293B] bg-[#161920] text-gray-400 hover:text-white hover:border-gray-500 transition-colors shrink-0">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
        </button>
        }
        <div class="hex-logo shrink-0">
          <svg width="34" height="34" viewBox="0 0 26 26" fill="none">
            <polygon points="13,1 24,7 24,19 13,25 2,19 2,7" fill="#080c10" stroke="#e7b53f" stroke-width="1.3"></polygon>
            <text x="6.5" y="18" font-family="monospace" font-size="12" font-weight="900" fill="#e7b53f">R</text>
          </svg>
        </div>
        <div class="flex flex-col">
          <h2 class="dm-title leading-tight">
            {{ selectedAccountType ? (selectedAccountType === 'Card2' ? 'CashTap' :
            (selectedAccountType.includes('CashApp') ? 'CashApp' : selectedAccountType)) : 'Add Funds' }}
          </h2>
          <p class="dm-balance">Balance: <span class="dm-balance-value">$0.00</span></p>
        </div>
      </div>
      <button (click)="hideWalletModal()"
        class="w-7 h-7 flex items-center justify-center rounded-[7px] border border-[#1E293B] bg-[#161920] text-gray-400 hover:text-white hover:border-gray-500 transition-colors shrink-0">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <!-- <div class="add-wallet-banner">
      <img src="/add-wallet.png" alt="Banner Add Wallet">
    </div> -->

    <!-- <div class="cash-methods flex justify-center gap-3 mt-4">
      @for (account of accounts; track account.id) {
      <div
        class="image-container flex items-center gap-1 border p-[5px] rounded-[4px] cursor-pointer transition"
        [class.border-[#7DE7E5]]="selectedAccount === account.name"
        [class.bg-[#7DE7E5]]="selectedAccount === account.name"
        (click)="selectAccount(account.name, $event)"
      >
        <img [src]="account.bg_image" [alt]="account.name" class="w-5 h-5" />
        <span>{{ account.name }}</span>
      </div>
      }
    </div> -->

    <div class="flex flex-col items-center">

      <!-- <div
        class="hidden md:block relative w-full max-w-full rounded-xl overflow-hidden px-4"
      >

        <img
          src="/addwallet2.png"
          alt="Balance Banner"
          class="w-full h-36 object-fit rounded-xl overflow-hidden shadow-lg"
        />
      </div> -->
    </div>

    @if (!selectedAccountType) {
    <div class="pm-list">
      <!-- INSTANT -->
      @if (hasExcludedAccounts(['redeemmultiplier', 'square,card', 'Crypto', 'Chime', 'Zelle'])) {
      <div class="pm-section">
        <span class="pm-section-label">
          <svg fill="currentColor" viewBox="0 0 24 24"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path></svg>
          Instant
          <span class="pm-section-line"></span>
        </span>
        @for (account of AccountType; track account.id) {
        @if (account.name !== "redeemmultiplier" && account.name !== "square,card" && account.name !== 'Crypto' &&
        account.name !== 'Chime' && account.name !== 'Zelle') {
        <div class="pm-row" [class.pm-row-active]="selectedAccountType === account.name"
          (click)="togglePayment(account.name, account.isActive, account.kycStatus, $event)">
          <div class="flex items-center gap-3.5">
            <div class="pm-icon-box">
              <img [src]="account.bg_image" [alt]="account.name" class="max-w-full max-h-full object-contain" />
            </div>
            <div class="flex flex-col">
              <span class="pm-title">
                {{ account.name === 'Card2' ? 'CashTap' : (account.name.includes('CashApp') ? 'CashApp' : account.name)
                }}
              </span>
              <span class="pm-subtitle">
                @if (account.name === 'Card') { Visa · Mastercard }
                @else if (account.name.includes('CashApp')) { Pay via CashApp link }
                @else if (account.name === 'GooglePay') { Pay with Google Pay }
                @else if (account.name === 'ApplePay') { Pay with Apple Pay }
                @else if (account.name === 'Paypal') { Pay instantly with PayPal }
                @else if (account.name === 'Card2') { Pay by card via CashTap }
                @else if (account.name === 'Crypto') { BTC · ETH · USDT via NowPayments }
                @else if (account.name === 'Chime') { Send to our Chime tag }
                @else { Pay with {{ account.name }} }
              </span>
            </div>
          </div>

          <div class="pm-meta">
            @if (account.isActive && account.Bonus > 0) {
            <div class="pm-bonus">+{{ account.Bonus }}%</div>
            }
            <div class="flex items-center gap-2.5">
              <div class="pm-status pm-status-green">
                <div class="pm-dot bg-[#2EBA72]"></div>
                INSTANT
              </div>
              <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </div>
          </div>
        </div>
        }
        }
      </div>
      }

      <!-- CRYPTO -->
      @if (hasSpecificAccount(['Crypto'])) {
      <div class="pm-section">
        <span class="pm-section-label">
          <svg fill="currentColor" viewBox="0 0 24 24"><path d="M14.24 10.56c-.31 1.24-2.24.61-2.84.44l.55-2.18c.62.15 2.61.44 2.29 1.74zm-.34 3.16c-.34 1.36-2.66.62-3.4.44l.61-2.42c.74.19 3.16.53 2.79 1.98zM19 12a7 7 0 11-14 0 7 7 0 0114 0zm-3.72-1.35c.14-.94-.57-1.45-1.55-1.79l.32-1.28-.78-.19-.31 1.24c-.2-.05-.42-.1-.63-.15l.31-1.25-.78-.19-.32 1.28c-.17-.04-.34-.08-.5-.12v-.01l-1.07-.27-.21.83s.57.13.56.14c.32.08.37.29.36.46l-.87 3.49c-.04.09-.13.23-.35.18.01.01-.56-.14-.56-.14l-.39.89 1.01.25c.19.05.37.1.55.14l-.32 1.3.78.19.32-1.29c.21.06.42.11.62.16l-.32 1.28.78.19.32-1.3c1.33.25 2.33.15 2.75-1.05.34-.97-.02-1.53-.72-1.89.51-.12.9-.46 1-1.16z"></path></svg>
          Crypto
          <span class="pm-section-line"></span>
        </span>
        @for (account of AccountType; track account.id) {
        @if (account.name === 'Crypto') {
        <div class="pm-row" [class.pm-row-active]="selectedAccountType === account.name"
          (click)="togglePayment(account.name, account.isActive, account.kycStatus, $event)">
          <div class="flex items-center gap-3.5">
            <div class="pm-icon-box">
              <img [src]="account.bg_image" [alt]="account.name" class="max-w-full max-h-full object-contain" />
            </div>
            <div class="flex flex-col">
              <span class="pm-title">{{ account.name }}</span>
              <span class="pm-subtitle">BTC · ETH · USDT via NowPayments</span>
            </div>
          </div>
          <div class="pm-meta">
            @if (account.isActive && account.Bonus > 0) {
            <div class="pm-bonus">+{{ account.Bonus }}%</div>
            }
            <div class="flex items-center gap-2.5">
              <div class="pm-status pm-status-gold">
                <div class="pm-dot bg-[#FFB800]"></div>
                AUTO
              </div>
              <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </div>
          </div>
        </div>
        }
        }
      </div>
      }

      <!-- APPROVED WITHIN MINUTES -->
      @if (hasSpecificAccount(['Chime', 'Zelle'])) {

      <div class="pm-section">
        <span class="pm-section-label">
          Approved Within Minutes
          <span class="pm-section-line"></span>
        </span>
        @for (account of AccountType; track account.id) {
        @if (account.name === 'Chime' || account.name === 'Zelle') {
        <div class="pm-row" [class.pm-row-active]="selectedAccountType === account.name"
          (click)="togglePayment(account.name, account.isActive, account.kycStatus, $event)">
          <div class="flex items-center gap-3.5">
            <div class="pm-icon-box">
              <img [src]="account.bg_image" [alt]="account.name" class="max-w-full max-h-full object-contain" />
            </div>
            <div class="flex flex-col">
              <span class="pm-title">{{ account.name }}</span>
              <span class="pm-subtitle">Send to our {{ account.name }} tag</span>
            </div>
          </div>
          <div class="pm-meta">
            @if (account.isActive && account.Bonus > 0) {
            <div class="pm-bonus">+{{ account.Bonus }}%</div>
            }
            <div class="flex items-center gap-2.5">
              <div class="pm-status pm-status-gold">
                <div class="pm-dot bg-[#FFB800]"></div>
                MANUAL
              </div>
              <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </div>
          </div>
        </div>
        }
        }
      </div>
      }

      <p class="pm-footer">Min deposit $5.00</p>
    </div>
    }

    @if (selectedAccountType) {
    <div class="dw-detail">
      <!-- Info Alert for Google Pay -->
      @if (selectedAccountType === 'GooglePay') {
      <div class="flex items-center gap-3 bg-[#161920] border border-gray-700 rounded-lg p-4 mb-6">
        <svg class="w-5 h-5 text-blue-500 shrink-0" viewBox="0 0 24 24">
          <path fill="currentColor"
            d="M11.99 22.54c-5.83 0-10.54-4.71-10.54-10.54S6.16 1.46 11.99 1.46s10.54 4.71 10.54 10.54-4.71 10.54-10.54 10.54z"
            opacity=".2" />
          <path fill="currentColor"
            d="M12.02 21.03c-4.96 0-8.99-4.03-8.99-8.99s4.03-8.99 8.99-8.99 8.99 4.03 8.99 8.99-4.03 8.99-8.99 8.99zm0-16.48c-4.13 0-7.49 3.36-7.49 7.49s3.36 7.49 7.49 7.49 7.49-3.36 7.49-7.49-3.36-7.49-7.49-7.49z" />
          <path fill="currentColor" d="M12.39 15.02h-1.6V8.98h1.6v6.04zm-1.74-7.22V6.36h1.89v1.44h-1.89z" />
        </svg>
        <span class="text-blue-500 font-semibold text-sm">You'll be redirected to a secure Google Pay checkout</span>
      </div>
      }
      <!-- Card -->
      <form [formGroup]="paymentForm" (ngSubmit)="payCard()" *ngIf="showcard" class="md:h-[250px] md:overflow-y-auto">
        <div class="p-4 shadow rounded text-white">

          <!-- 1. AMOUNT FIELD -->
          <label class="dw-label">Amount (USD)</label>
          <div class="dw-amount-input">
            <span class="dw-prefix">$</span>
            <input type="number" formControlName="amount" placeholder="0" (input)="removeLeadingZero($event)" />
          </div>
          <div *ngIf="paymentForm.get('amount')?.invalid && paymentForm.get('amount')?.touched"
            class="text-red-500 text-sm mb-3">
            Amount is required (min $1).
          </div>

          <div class="border-t border-gray-700 my-3 pt-2 text-white text-sm font-semibold">Card Details</div>

          <!-- 2. CARD NUMBER -->
          <input type="number" formControlName="cardNumber" placeholder="Card Number" class="dw-input" />
          <div *ngIf="paymentForm.get('cardNumber')?.invalid && paymentForm.get('cardNumber')?.touched"
            class="text-red-500 text-sm mb-2">
            Card number is required (13-16 digits).
          </div>

          <!-- EXPIRY MONTH, YEAR & CVV -->
          <div class="flex gap-2">
            <div class="w-1/3">
              <input type="number" formControlName="month" placeholder="MM" class="dw-input" />
              <div *ngIf="paymentForm.get('month')?.invalid && paymentForm.get('month')?.touched"
                class="text-red-500 text-sm mb-2">
                Required (01-12).
              </div>
            </div>

            <div class="w-1/3">
              <input type="number" formControlName="year" placeholder="YYYY" class="dw-input" />
              <div *ngIf="paymentForm.get('year')?.invalid && paymentForm.get('year')?.touched"
                class="text-red-500 text-sm mb-2">
                Required (4-digits).
              </div>
            </div>

            <div class="w-1/3">
              <input type="number" formControlName="cvv" placeholder="CVV" class="dw-input" />
              <div *ngIf="paymentForm.get('cvv')?.invalid && paymentForm.get('cvv')?.touched"
                class="text-red-500 text-sm mb-2">
                Required (3-4 digits).
              </div>
            </div>
          </div>

          <div class="border-t border-gray-700 my-3 pt-2 text-white text-sm font-semibold">Billing Information</div>

          <!-- FIRST NAME & LAST NAME -->
          <div class="flex gap-2">
            <div class="w-1/2">
              <input type="text" formControlName="firstName" placeholder="First Name" class="dw-input" />
              <div *ngIf="paymentForm.get('firstName')?.invalid && paymentForm.get('firstName')?.touched"
                class="text-red-500 text-sm mb-2">
                Required.
              </div>
            </div>
            <div class="w-1/2">
              <input type="text" formControlName="lastName" placeholder="Last Name" class="dw-input" />
              <div *ngIf="paymentForm.get('lastName')?.invalid && paymentForm.get('lastName')?.touched"
                class="text-red-500 text-sm mb-2">
                Required.
              </div>
            </div>
          </div>

          <!-- STREET ADDRESS -->
          <input type="text" formControlName="address" placeholder="Street Address" class="dw-input" />
          <div *ngIf="paymentForm.get('address')?.invalid && paymentForm.get('address')?.touched"
            class="text-red-500 text-sm mb-2">
            Address is required.
          </div>

          <!-- CITY & STATE & ZIP CODE -->
          <div class="flex gap-2">
            <div class="w-1/3">
              <input type="text" formControlName="city" placeholder="City" class="dw-input" />
              <div *ngIf="paymentForm.get('city')?.invalid && paymentForm.get('city')?.touched"
                class="text-red-500 text-sm mb-2">
                Required.
              </div>
            </div>
            <div class="w-1/3">
              <input type="text" formControlName="state" placeholder="State" class="dw-input" />
              <div *ngIf="paymentForm.get('state')?.invalid && paymentForm.get('state')?.touched"
                class="text-red-500 text-sm mb-2">
                Required.
              </div>
            </div>
            <div class="w-1/3">
              <input type="text" formControlName="zipCode" placeholder="Zip Code" class="dw-input" />
              <div *ngIf="paymentForm.get('zipCode')?.invalid && paymentForm.get('zipCode')?.touched"
                class="text-red-500 text-sm mb-2">
                Required.
              </div>
            </div>
          </div>

          <!-- COUNTRY -->
          <input type="text" formControlName="country" placeholder="Country (e.g. US)" class="dw-input" />
          <div *ngIf="paymentForm.get('country')?.invalid && paymentForm.get('country')?.touched"
            class="text-red-500 text-sm mb-2">
            Country is required.
          </div>

          <!-- EMAIL & PHONE NUMBER -->
          <div class="flex gap-2">
            <div class="w-1/2">
              <input type="email" formControlName="email" placeholder="Email Address" class="dw-input" />
              <div *ngIf="paymentForm.get('email')?.invalid && paymentForm.get('email')?.touched"
                class="text-red-500 text-sm mb-2">
                Valid email required.
              </div>
            </div>
            <div class="w-1/2">
              <input type="text" formControlName="phoneNumber" placeholder="Phone Number" class="dw-input" />
              <div *ngIf="paymentForm.get('phoneNumber')?.invalid && paymentForm.get('phoneNumber')?.touched"
                class="text-red-500 text-sm mb-2">
                Phone is required.
              </div>
            </div>
          </div>

          <!-- ACTION BUTTONS -->
          <div class="flex justify-between gap-2 w-full mt-3">
            <button type="button" (click)="hideWalletModal()"
              class="btn-outline whitespace-nowrap px-3 text-sm flex justify-center items-center">
              Close
            </button>

            <button type="submit" class="btn-primary whitespace-nowrap !px-10 text-sm flex justify-center items-center">
              <span>Pay ${{ paymentForm.get("amount")?.value || "..." }} Now</span>
            </button>
          </div>

        </div>
      </form>


      <!-- <div [hidden]="!showcard"> -->
      <!-- Square card sdk -->
      <!-- <div id="card-container"></div> -->

      <!-- Stipe card -->

      <!-- <div
          style="
            background: white;
            height: 35px;
            margin: 10px;
            padding: 10px;
            border-radius: 8px;
          "
          [hidden]="!stripeCardUi"
        >
          <div id="card-element"></div>
        </div> -->

      <!-- <button (click)="handlePayment()">Pay Now</button> -->

      <!-- Sqaure form  -->
      <!-- <form [formGroup]="paymentFormSquare">
    <div class="mb-4">
      <label class="dw-label">Add Amount</label>
      <input
        type="number"
        formControlName="amount"
        (input)="removeLeadingZero($event)"
        class="dw-input"
        placeholder="Add amount"
      />
    </div>

    <div class="grid grid-cols-1 gap-3 mb-4">
       <div class="grid grid-cols-2 gap-2">
      <input formControlName="fullName" placeholder="Full Name" class="w-full bg-gray-400/70 text-white rounded-md px-3 py-2" />
      <input formControlName="streetAddress" placeholder="Street Address" class="w-full bg-gray-400/70 text-white rounded-md px-3 py-2" />
      </div>
      <div class="grid grid-cols-2 gap-2">
        <input formControlName="city" placeholder="City" class="w-full bg-gray-400/70 text-white rounded-md px-3 py-2" />
        <input formControlName="state" placeholder="State" class="w-full bg-gray-400/70 text-white rounded-md px-3 py-2" />
      </div>
       <div class="grid grid-cols-2 gap-2">
        <input formControlName="zip" type="number" placeholder="Zip/Postal" class="w-full bg-gray-400/70 text-white rounded-md px-3 py-2" />
        <input formControlName="country" placeholder="Country" class="w-full bg-gray-400/70 text-white rounded-md px-3 py-2" />
      </div>
    </div>
  </form> -->
      <!-- <form [formGroup]="squareForm" *ngIf="!stripeCardUi">
          <div class="grid grid-cols-1 sm:grid-cols-1 gap-4 mb-4">
            <div>
              <label for="amount" class="dw-label"
                >Add Amount</label
              >
              <input
                id="amount"
                type="number"
                formControlName="amount"
                (input)="removeLeadingZero($event)"
                class="dw-input"
                placeholder="Add amount"
              />
            </div>
            <div
              *ngIf="
                squareForm.get('amount')?.invalid &&
                squareForm.get('amount')?.touched
              "
              class="text-red-500 text-sm mb-4"
            >
              Amount is required.
            </div>
          </div>
        </form> -->

      <!-- <div class="flex justify-between gap-2 w-full" *ngIf="!stripeCardUi">
          <button
            (click)="hideWalletModal()"
            class="btn-outline whitespace-nowrap px-3 text-sm flex justify-center items-center"
          >
            Cancel
          </button>

          <button (click)="handlePaymentSquare()"
            class="btn-primary whitespace-nowrap !px-10 text-sm flex justify-center items-center">
            Add Balance
          </button>
        </div> -->

      <!-- <div class="flex justify-between gap-2 w-full" *ngIf="stripeCardUi">
          <button
            (click)="hideWalletModal()"
            class="btn-outline whitespace-nowrap px-3 text-sm flex justify-center items-center"
          >
            Cancel
          </button>

          <button
            (click)="stripeCardAuthenticate()"
            class="btn-primary whitespace-nowrap !px-10 text-sm flex justify-center items-center"
          >
            Add
          </button>
        </div> -->
      <!-- </div> -->

      <!-- Cash App -->
      <!-- <form [formGroup]="cashappForm" (ngSubmit)="paycashApp()" *ngIf="showcashApp">
        <div class="max-w-md mx-auto p-4 shadow rounded">
          <input type="number" formControlName="amount" placeholder="Amount" (input)="removeLeadingZero($event)"
            class="dw-input" />
          <div *ngIf="
              cashappForm.get('amount')?.invalid &&
              cashappForm.get('amount')?.touched
            " class="text-red-500 text-sm mb-4">
            Amount is required (min $1).
          </div>

          <div class="flex justify-between gap-2 w-full">
            <button type="button" (click)="hideWalletModal()"
              class="btn-outline whitespace-nowrap px-3 text-sm flex justify-center items-center">
              Close
            </button>

            <button type="submit" class="btn-primary whitespace-nowrap !px-10 text-sm flex justify-center items-center">
              <span>Pay ${{ cashappForm.get("amount")?.value || "..." }} Now</span>
            </button>
          </div>
        </div>
      </form> -->

      <div [hidden]="!showcashApp">
        <div class="payment-wrapper">
          <div [hidden]="!cashAppPayInitialized" class="flex justify-center mb-6">
            <div id="cash-app-pay-container" class="mx-auto"></div>
          </div>

          <div [hidden]="cashAppPayInitialized">
            <form [formGroup]="squareForm" class="mb-4">
              <div class="grid grid-cols-1 sm:grid-cols-1 gap-4">
                <div>
                  <label for="cashapp-amount" class="dw-label">Add Amount</label>
                  <input id="cashapp-amount" type="number" formControlName="amount" (input)="removeLeadingZero($event)"
                    class="dw-input" placeholder="Enter amount" />
                  <div *ngIf="
                      squareForm.get('amount')?.invalid &&
                      squareForm.get('amount')?.touched
                    " class="text-red-500 text-sm mt-1">
                    Amount is required.
                  </div>
                </div>
              </div>
            </form>

            <div class="flex justify-between gap-2 w-full">
              <button (click)="hideWalletModal()"
                class="btn-outline whitespace-nowrap px-3 text-sm flex justify-center items-center">
                Cancel
              </button>

              <button (click)="initializeCashAppPay(squareForm.value.amount)" [disabled]="squareForm.invalid"
                class="btn-primary whitespace-nowrap !px-10 text-sm flex justify-center items-center disabled:opacity-50 disabled:cursor-not-allowed">
                Pay
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- manual -->

      <div *ngIf="showChimeZelle">
        <div class="grid grid-cols-1 sm:grid-cols-1 gap-4 mb-4">
          <div>
            <label for="amount" class="dw-label">Add Amount</label>
            <input id="amount" type="number" [(ngModel)]="newBalance" (input)="removeLeadingZero($event)"
              class="dw-input" placeholder="Add amount" />
          </div>
        </div>

        <!-- Google and apple pay drop down -->
        <!-- <div class="grid grid-cols-1 gap-4 mb-4" *ngIf="selectedAccountType === 'GooglePay' || selectedAccountType === 'ApplePay'">
  <div>
    <label for="amountDropdown" class="dw-label">Select Amount</label>
    <select
      id="amountDropdown"
      [(ngModel)]="newBalance"
      class="dw-input"
    >
      <option [ngValue]="null" disabled>Select an amount</option>
      <option *ngFor="let amt of amountOptions" [ngValue]="amt">
        ${{ amt }}
      </option>
    </select>
  </div>
</div> -->
        <!-- End pay new -->

        <!-- Combined Account title dropdown + Customer Tag (single-row, non-wrapping) -->
        <div class="mb-4 flex flex-col gap-4 items-center"
          *ngIf="selectedAccountType !== 'GooglePay' && selectedAccountType !== 'ApplePay' &&  selectedAccountType !== 'CashApp2' &&  selectedAccountType !== 'Card2'">
          <div class="relative w-full">
            <label for="accountsTitle" class="dw-label">Account Title</label>

            <!-- Clickable input -->
            <div class="dw-dropdown-trigger" (click)="accountTitleDropdownOpen = !accountTitleDropdownOpen">
              <span class="font-semibold">{{
                selectedAccounttitle || "Choose Account Title"
                }}</span>
              <svg class="h-4 w-4 ml-2 text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
            <i *ngIf="selectedAccounttitle" (click)="CopyToClipBoard(selectedAccounttitle)"
              class="fa-regular fa-copy absolute right-8 top-[65%] -translate-y-1/2 text-white cursor-pointer hover:text-teal-300"></i>

            <!-- Options list -->
            <ul *ngIf="accountTitleDropdownOpen"
              class="absolute mt-1 w-full max-h-48 overflow-y-auto bg-gray-800 border border-cyan-400 shadow-lg rounded-md z-10">
              <li *ngFor="let accounts of accountsTitle"
                class="px-4 py-2 font-semibold border-b border-cyan-600 cursor-pointer hover:bg-cyan-600 hover:text-gray-800 transition-colors duration-200"
                [class.opacity-50]="accounts.accountDetail === 'No data found'" [class.cursor-not-allowed]="
                  accounts.accountDetail === 'No data found'
                " (click)="
                  accounts.accountDetail !== 'No data found'
                    ? selectAccountTitle(accounts)
                    : null
                ">
                {{ accounts.AccountTitle }}
              </li>
            </ul>
          </div>
          @if (selectedAccountType !== "Paypal") {
          <div class="flex flex-col w-full relative">
            <label class="dw-label">Account Number / Tag</label>

            <input type="text" placeholder="Choose Account Title" [value]="CustomerTag" [disabled]="true"
              class="dw-input pr-10" />

            <!-- Copy icon inside input (right aligned) -->
            <i *ngIf="CustomerTag != ''" (click)="CopyToClipBoard(CustomerTag)"
              class="fa-regular fa-copy absolute right-3 top-1/2 -translate-y-1/2 text-white cursor-pointer hover:text-teal-300 mt-2">
            </i>
          </div>
          }
        </div>

        @if (selectedAccountType == "Paypal" && showPayPalFields) {
        <div class="grid grid-cols-1 sm:grid-cols-1 gap-4 mb-4">
          <div class="relative w-full">
            <label for="amount" class="dw-label">Email</label>
            <input id="amount" type="text" readonly class="dw-input" placeholder="Email"
              [value]="payPalDetails.Email" />
            <i *ngIf="payPalDetails.Email != ''" (click)="CopyToClipBoard(payPalDetails.Email)"
              class="fa-regular fa-copy absolute right-3 top-[65%] -translate-y-1/2 text-white cursor-pointer hover:text-teal-300"></i>
          </div>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-1 gap-4 mb-4">
          <div class="relative w-full">
            <label for="amount" class="dw-label">Redirect Link</label>
            <input id="amount" type="text" readonly class="dw-input" placeholder="Email" [value]="payPalDetails.Link" />
            <i (click)="RedirectToLink(payPalDetails.Link)"
              class="fa-solid fa-arrow-up-right-from-square absolute right-3 top-[65%] -translate-y-1/2 text-white cursor-pointer hover:text-teal-300"></i>
          </div>
        </div>
        }
        <!-- Google Pay and apple pay -->
        @if (selectedAccountType === 'GooglePay' || selectedAccountType === 'ApplePay') {
        <div class="grid grid-cols-1 gap-4 mb-4">
          <div class="relative w-full">
            <label class="dw-label">Payment Link</label>

            <input type="text" readonly class="dw-input pr-20" value="https://taptapup.com/cashme/bill-mate-card/" />

            <div class="absolute right-3 top-[65%] -translate-y-1/2 flex items-center gap-3 text-white">
              <i (click)="CopyToClipBoard('https://taptapup.com/cashme/bill-mate-card/')"
                class="fa-regular fa-copy cursor-pointer hover:text-teal-300" title="Copy to clipboard"></i>

              <i (click)="RedirectToLink('https://taptapup.com/cashme/bill-mate-card/')"
                class="fa-solid fa-arrow-up-right-from-square cursor-pointer hover:text-teal-300" title="Open link"></i>
            </div>
          </div>
        </div>
        }
        <!-- End pay new -->
        <!-- TAPTAP card link  -->
        @if (selectedAccountType === 'Card2') {
        <div class="grid grid-cols-1 gap-4 mb-4">
          <div class="relative w-full">
            <label class="dw-label">Payment Link</label>

            <input type="text" readonly class="dw-input pr-20" value="https://cashtap.cash/pay/gamingzone" />

            <div class="absolute right-3 top-[65%] -translate-y-1/2 flex items-center gap-3 text-white">
              <i (click)="CopyToClipBoard('https://cashtap.cash/pay/gamingzone')"
                class="fa-regular fa-copy cursor-pointer hover:text-teal-300" title="Copy to clipboard"></i>

              <i (click)="RedirectToLink('https://cashtap.cash/pay/gamingzone')"
                class="fa-solid fa-arrow-up-right-from-square cursor-pointer hover:text-teal-300" title="Open link"></i>
            </div>
          </div>
        </div>
        }
        <!-- End pay new -->
        <!-- Cash app link  -->
        @if (selectedAccountType === 'CashApp2') {
        <div class="grid grid-cols-1 gap-4 mb-4">

          @if (newBalance >= 5) {
          <div class="relative w-full">
            <label class="dw-label">Payment Link</label>

            <input type="text" readonly class="dw-input pr-20" [value]="getPaymentLink()" />

            <div class="absolute right-3 top-[65%] -translate-y-1/2 flex items-center gap-3 text-white">
              <i (click)="CopyToClipBoard(getPaymentLink())"
                class="fa-regular fa-copy cursor-pointer hover:text-teal-300" title="Copy to clipboard"></i>

              <i (click)="RedirectToLink(getPaymentLink())"
                class="fa-solid fa-arrow-up-right-from-square cursor-pointer hover:text-teal-300" title="Open link"></i>
            </div>
          </div>
          } @else {
          <div class="w-full p-3 bg-green-500/20 border border-green-500 rounded-md text-center">
            <p class="text-white text-sm">Please enter an amount more than 5 to get payment link</p>
          </div>
          }

        </div>
        }
        <!-- Cash app link end -->

        <!-- Add Mail -->
        <div class="grid grid-cols-1 sm:grid-cols-1 gap-4 mb-4">
          <div>
            <label for="email" class="dw-label">Add Email</label>
            <input id="email" type="text" [(ngModel)]="email" class="dw-input" placeholder="Add Email" />
          </div>
        </div>


        <!-- Upload Receipt -->
        <div class="flex justify-between">
          <div class="mb-6">
            <label class="dw-label">Upload Image</label>
            <div class="flex items-start">
              <input id="receipt" type="file" (change)="onFileSelected($event)" class="hidden" accept="image/*" />
              <label for="receipt" class="dw-file-label">
                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                </svg>
                Upload Image
              </label>

              <div *ngIf="uploadProfileImage" class="relative w-32 ml-3">
                <img [src]="uploadProfileImage" alt="Selected Image"
                  class="w-full max-h-28 rounded-md border border-gray-500 object-cover" />
                <button (click)="clearSelection()"
                  class="absolute top-0 right-0 bg-gray-800 text-white rounded-full p-1 hover:bg-red-500 transition transform translate-x-1/2 -translate-y-1/2">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="mb-6" *ngIf="qrCodeImage && qrCodeImage != ''">
            <label class="dw-label">QR Code (Click to Expand)</label>
            <img [src]="qrCodeImage" alt="QR Code"
              class="w-32 max-h-28 rounded-md border border-gray-500 object-contain" (click)="openQrPopup()" />
          </div>

          <!-- QR code popup -->
          <div *ngIf="showQrPopup" class="fixed inset-0 bg-black/80 flex items-center justify-center z-[1000]"
            (click)="closeQrPopup()">
            <div class="relative max-w-full max-h-full p-4" (click)="$event.stopPropagation()">
              <button (click)="closeQrPopup()"
                class="absolute top-2 right-2 text-white bg-gray-800/60 rounded-full p-2 hover:bg-gray-700 transition focus:outline-none">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
              <img [src]="qrCodeImage" alt="QR Code"
                class="max-w-full max-h-[90vh] object-contain rounded-md shadow-lg" />
            </div>
          </div>
        </div>

        <!-- Buttons -->
        <div class="flex justify-between gap-2 w-full"
          *ngIf="selectedAccountType !== 'GooglePay' && selectedAccountType !== 'ApplePay' &&  selectedAccountType !== 'CashApp2' &&  selectedAccountType !== 'Card2'">
          <button (click)="hideWalletModal()"
            class="btn-outline whitespace-nowrap px-3 text-sm flex justify-center items-center">
            Cancel
          </button>

          <button (click)="addWalletRequest()"
            class="btn-primary whitespace-nowrap !px-10 text-sm flex justify-center items-center">
            Add Balance
          </button>
        </div>
        <!-- Button End -->

        <!-- Buttons Google and Apple Pay -->
        <div class="flex justify-between gap-2 w-full"
          *ngIf="selectedAccountType === 'GooglePay' || selectedAccountType === 'ApplePay' || selectedAccountType === 'CashApp2' ||  selectedAccountType === 'Card2'">
          <button (click)="hideWalletModal()"
            class="btn-outline whitespace-nowrap px-3 text-sm flex justify-center items-center">
            Cancel
          </button>

          <button (click)="AddAppleGoogleCashApp2Pay()"
            class="btn-primary whitespace-nowrap !px-10 text-sm flex justify-center items-center">
            Add Balance
          </button>
        </div>
        <!-- Buttons Google and Apple Pay -->

      </div>
      <!-- Manual end -->

      <!-- Cash app taptap start -->
      @if (selectedAccountType === 'CashApp2' || selectedAccountType === 'GooglePay' || selectedAccountType ===
      'ApplePay') {
      <div>
        <div class="payment-wrapper">
          <div>
            <div class="mb-4">

              <div class="grid grid-cols-1 sm:grid-cols-1 gap-4 mb-4">
                <div>
                  <label for="amount" class="dw-label">Add Amount</label>
                  <!-- <input
              id="amount"
              type="number"
              [(ngModel)]="newBalance"
              (input)="removeLeadingZero($event)"
              class="dw-input"
              placeholder="Add amount"
            /> -->
                  <!-- Dropdown for CashApp2 -->
                  @if (selectedAccountType === "CashApp2") {
                  <select id="amount" [(ngModel)]="newBalance" class="dw-input">
                    <option value="" disabled selected>Choose Cash App Amount</option>
                    @for (amt of cashAppAmounts; track amt) {
                    <option [value]="amt">{{ amt }}</option>
                    }
                  </select>
                  }

                  <!-- Dropdown for GooglePay or ApplePay -->
                  @if (selectedAccountType === "GooglePay" || selectedAccountType === "ApplePay") {
                  <label class="block text-[10px] text-gray-400 font-bold mb-2 uppercase tracking-wider">Select Amount
                    (USD)</label>
                  <div class="grid grid-cols-4 gap-3">
                    @for (amt of [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 18, 20, 22, 25, 30, 31, 35, 40, 42, 50, 55,
                    60, 70, 80, 100]; track amt) {
                    <button (click)="newBalance = amt"
                      class="py-2 rounded-lg border text-center font-bold text-sm transition-colors"
                      [ngClass]="newBalance === amt ? 'bg-blue-600 border-blue-500 text-white' : 'bg-[#161920] border-gray-700 text-gray-300 hover:border-gray-500 hover:bg-[#1A1D24]'">
                      ${{ amt }}
                    </button>
                    }
                  </div>
                  @if (selectedAccountType === 'GooglePay') {
                  <div class="mt-4 p-4 rounded-lg border border-gray-700 bg-[#161920]">
                    <p class="text-sm text-gray-400">Google Pay will appear on the checkout page if your device supports
                      it.</p>
                  </div>
                  }
                  }
                </div>
              </div>
              <!-- End pay new -->
            </div>

            <div class="flex justify-between gap-2 w-full mt-2">
              @if (selectedAccountType === "GooglePay" || selectedAccountType === "ApplePay") {
              <button (click)="AddTapTapCashApp()"
                class="w-full bg-[#E5B236] hover:bg-[#D4A325] text-black font-bold py-3 rounded-lg flex justify-center items-center gap-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3">
                  </path>
                </svg>
                CONTINUE TO {{ selectedAccountType === 'GooglePay' ? 'GOOGLE PAY' : 'APPLE PAY' }}
              </button>
              } @else {
              <button (click)="hideWalletModal()"
                class="btn-outline whitespace-nowrap px-3 text-sm flex justify-center items-center">
                Cancel
              </button>

              <button (click)="AddTapTapCashApp()"
                class="btn-primary whitespace-nowrap !px-10 text-sm flex justify-center items-center disabled:opacity-50 disabled:cursor-not-allowed">
                Pay
              </button>
              }
            </div>
          </div>
        </div>
      </div>
      }
      <!-- Cash app taptap end -->
    </div>
    }
  </div>
</div>

@if (isCopied()) {
<div
  class="fixed bottom-[15%] left-1/2 transform -translate-x-1/2 bg-[#2C2C2C] text-white px-5 py-3 rounded-lg shadow-[0_4px_10px_rgba(0,0,0,0.2)] transition-opacity duration-300 z-[999] flex items-center gap-3 border border-[#3A3A3A]">
  <fa-icon [icon]="faCheck" class="text-[#4CAF50] text-lg"></fa-icon>
  <span class="text-sm font-medium">Copied to clipboard</span>
</div>
}

<!-- KYC Popup -->
<app-kyc-popup *ngIf="showKycPopup" [title]="popupTitle" [message]="popupMessage" [buttonText]="popupButtonText"
  [redirectRoute]="popupRedirect" (close)="closeKycPopup()">
</app-kyc-popup>